import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Revision } from '../../../version-control/revision/revision.model';
import _ from 'lodash';

@Component({
    selector: 'adm4-deployment-revision-information',
    template: `
    <div>
      <div class='deployment-detail-label'>Commit ID</div>
      <div class='copy-clipboard-container'>
        <div class='text-to-copy'>{{commitId}}</div>
        <mat-icon [cdkCopyToClipboard]="commitId">content_copy</mat-icon>
      </div>
      @if (hasComment) {
        <div class='deployment-detail-label'>Comment</div>
        @if (revision.message && {showMore: false}; as showMoreInfo ) {
          <div>
            <div class='comment-content'>
              {{(showMoreInfo.showMore) ? revision.message : (revision.message | slice:0:50)}}
              @if (!showMoreInfo.showMore && revision.message.length > 50) {
                <span>...</span>
                }<br>
                @if (!showMoreInfo.showMore && revision.message.length > 50) {
                  <a (click)="showMoreInfo.showMore=true">Show More</a>
                }
              </div>
            </div>
          }
        }
      </div>
    `,
    styleUrls: ['./deployment-revision-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DeploymentRevisionInformationComponent {
  @Input() commitId: string;
  @Input() revision: Revision | null;

  get hasComment(): boolean {
    return !_.isNil(this.revision) && !_.isEmpty(this.revision.message);
  }
}
